/* Lorenge quiz (Gustav build, job 20261023-0909): drives the source quiz screens client-side.
   No answer leaves the browser: no form submission, no tracking calls, no storage. */
(function () {
  var CFG = window.LQ || {};
  function qsCarry(url) {
    try {
      var u = new URL(url, location.href), cur = new URLSearchParams(location.search);
      cur.forEach(function (v, k) { if (k !== 'view' && k !== 'preview_theme_id' && !u.searchParams.has(k)) u.searchParams.set(k, v); });
      return u.pathname + u.search + u.hash;
    } catch (e) { return url; }
  }
  class LqQuiz extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      var root = this.attachShadow({ mode: 'open' });
      var link = document.createElement('link'); link.rel = 'stylesheet'; link.href = CFG.css;
      var art = document.createElement('article'); art.className = 'heyflow-widget-root'; art.setAttribute('lang', CFG.article_lang || 'it-IT'); art.style.width = '800px';
      var body = document.createElement('body');
      body.innerHTML = document.getElementById('lq-quiz-tpl').innerHTML;
      art.appendChild(body); root.appendChild(link); root.appendChild(art);
      this.root = root; this.body = body;
      this.screens = Array.prototype.slice.call(body.querySelectorAll('form > section[data-type=user]'));
      this.header = body.querySelector('#template-header'); this.footer = body.querySelector('#template-footer');
      this.bar = body.querySelector('.progress-bar-active');
      this.answers = {};
      var self = this;
      body.addEventListener('change', function (e) { self.onChange(e); });
      body.addEventListener('click', function (e) { self.onClick(e); });
      body.addEventListener('submit', function (e) { e.preventDefault(); });
      body.querySelectorAll('form').forEach(function (f) { f.setAttribute('novalidate', ''); f.removeAttribute('action'); });
      var go = function () { self.show(0, true); };
      if (link.sheet) go(); else { link.addEventListener('load', go); link.addEventListener('error', go); setTimeout(go, 3000); }
    }
    show(i, first) {
      if (first && this._shown) return; this._shown = true;
      var s = this.screens[i]; if (!s) return;
      this.cur = i;
      this.screens.forEach(function (x) { x.classList.remove('visible'); });
      s.classList.add('visible');
      if (this.header) this.header.style.display = s.getAttribute('data-header') ? 'block' : 'none';
      if (this.footer) this.footer.style.display = s.getAttribute('data-footer') ? 'block' : 'none';
      var n = this.screens.length;
      if (this.bar) this.bar.style.width = (i === 0 ? 0 : Math.round((i + 1) / n * 10000) / 100) + '%';
      if (!first) { var top = this.getBoundingClientRect().top + window.pageYOffset - 40; if (window.pageYOffset > top) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' }); }
      // profile screen: print the answer of the step that sets the variable
      var self = this;
      s.querySelectorAll('[data-lq-var]').forEach(function (v) { v.textContent = self.answers[v.getAttribute('data-lq-var')] || ''; });
      var ld = s.querySelector('[data-lq-timeout]');
      if (ld) { clearTimeout(this._t); this._t = setTimeout(function () { if (self.cur === i) self.next(); }, parseInt(ld.getAttribute('data-lq-timeout'), 10) || 3000); }
    }
    next() { if (this.cur < this.screens.length - 1) this.show(this.cur + 1); }
    collect(fs) {
      var name = fs.closest('[data-blockid]') ? fs.closest('[data-blockid]').getAttribute('data-blockid') : '';
      var vals = [];
      fs.querySelectorAll('input:checked').forEach(function (inp) {
        var a = inp.getAttribute('data-answer'); if (a === null) { var lab = inp.closest('label'); var t = lab && lab.querySelector('.label'); a = t ? t.textContent.trim() : ''; } vals.push(a);
      });
      // the variable printed on the profile screen is the area step (first multi-choice with a variable in the source)
      var v = fs.querySelector('input[data-variable]:not([data-variable=""])'); var key = v && v.getAttribute('data-variable');
      if (!key && fs.closest('section') === this.screens[1]) key = 'Waar-Haaruitval';
      if (key) this.answers[key] = vals.join(', ');
      this.answers[name] = vals;
    }
    onChange(e) {
      var inp = e.target; if (!inp.matches || !inp.matches('input[type=radio],input[type=checkbox]')) return;
      var fs = inp.closest('fieldset'); if (!fs) return;
      this.collect(fs);
      if (inp.type === 'radio' && fs.getAttribute('data-lq-auto') === '1') {
        var self = this, at = this.cur; setTimeout(function () { if (self.cur === at) self.next(); }, 300);
      }
    }
    onClick(e) {
      var b = e.target.closest && e.target.closest('button'); if (!b) return;
      e.preventDefault();
      var act = b.getAttribute('data-lq-action') || 'next';
      if (act === 'submit') { window.location.href = qsCarry(CFG.product_url); return; }
      var s = this.screens[this.cur]; s && s.querySelectorAll('fieldset').forEach(this.collect.bind(this));
      this.next();
    }
  }
  if (!customElements.get('lq-quiz')) customElements.define('lq-quiz', LqQuiz);
})();
